import { render, staticRenderFns } from "./all-year.vue?vue&type=template&id=688e8806"
import script from "./all-year.vue?vue&type=script&lang=js"
export * from "./all-year.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports